
import ChatIcon from '@/components/FileViewerModules/Chattable/ChatIcon.vue'
import ScrollContainer from '@/components/FileViewerModules/Chattable/ScrollContainer.vue'
import DropDownMenu from '@/components/FileViewerModules/Chattable/DropDownMenu.vue'
import DropDownMenuItem from '@/components/FileViewerModules/Chattable/DropDownMenuItem.vue'
import UpdateOrCreateChatRoom from '@/components/FileViewerModules/Chattable/Modals/UpdateOrCreateChatRoom.vue'
import SectionLabel from '@/components/FileViewer/SectionLabel.vue'
import DeleteChatRoom from '@/components/FileViewerModules/Chattable/Modals/DeleteChatRoom.vue'
import ChatRoom from '@/components/FileViewerModules/Chattable/ChatRoom.vue'
import ChatMessage from '@/components/FileViewerModules/Chattable/ChatMessage.vue'
import ChatMessageInput from '@/components/FileViewerModules/Chattable/ChatMessageInput.vue'
import FilterInput from '@/components/FileViewerModules/Chattable/Inputs/FilterInput.vue'
import EmptyState from '@/components/FileViewerModules/Chattable/EmptyState.vue'
import Button from '@/components/UntitledUI/Button.vue'
import DateTimeUtils from '@/components/FileViewerModules/Chattable/Mixins/DateTimeUtils.js'
import Icon from './Icon.vue'

export default {
    name: 'Chatable',
    Name: 'Chatable',
    Icons: [Icon],
    components: {
        Button,
        EmptyState,
        FilterInput,
        ChatMessageInput,
        ChatMessage,
        ChatRoom,
        DeleteChatRoom,
        UpdateOrCreateChatRoom,
        DropDownMenu,
        DropDownMenuItem,
        ChatIcon,
        SectionLabel,
        ScrollContainer
    },
    mixins: [DateTimeUtils],
    props: {
        meta: {
            type: Object,
            required: true
        },
        isLogged: {
            type: Boolean,
            required: true
        }
    },
    data () {
        return {
            loadChatRoomMessagesRequest: new this.$vForm({
                message_id: null,
                dir: null
            }),
            getChatRoomMessagesRequest: new this.$vForm(),
            updateChatRoomStatusRequest: new this.$vForm({
                status: null
            }),
            getChatRoomsRequest: new this.$vForm({
                chatable_type: null,
                chatable_id: null,
                status: this.filter
            }),
            createOrUpdateChatRoomRequest: new this.$vForm({
                name: null,
                chatable_type: 'file',
                chatable_id: this.meta.hash
            }),
            getChatRoomMembersRequest: new this.$vForm(),
            rooms: [],
            selectedChatRoomMessages: [],
            selectedChatRoomMembers: [],
            filter: null,
            selectedChatRoom: null,
            oldestUnreadMessageId: null,
            modal: null,
            thereIsNewMessages: false,
            /**
             * this chat room should be opened as soon as chat rooms are loaded
             */
            awaitingChatRoomId: null
        }
    },
    computed: {
        roomsOrderByLatest () {
            return this.rooms.sort((a, b) => new Date(b.latest_message.updated_at) - new Date(a.latest_message.updated_at))
        },
        lastSelectedChatRoomMessage () {
            return this.messagesGroupByDateOrderByLatest.at(-1).messages.at(-1)
        },
        firstSelectedChatRoomMessage () {
            return this.messagesGroupByDateOrderByLatest.at(0).messages.at(0)
        },
        messagesGroupByDateOrderByLatest () {
            const messages = this.selectedChatRoomMessages.sort((a, b) => {
                const aDate = new Date(a.updated_at)
                const bDate = new Date(b.updated_at)

                return aDate - bDate
            })
            const groupByDate = []
            messages.forEach((message) => {
                const date = new Date(message.updated_at)
                const month = date.getMonth() <= 9 ? `0${date.getMonth()}` : date.getMonth()
                const day = date.getDate() <= 9 ? `0${date.getDate()}` : date.getDate()
                const dateString = `${date.getFullYear()}-${month}-${day}`
                let groupIndex = groupByDate.findIndex(g => g.date === dateString)
                if (groupIndex === -1) {
                    groupByDate.push({ date: dateString, messages: [] })
                    groupIndex = groupByDate.length - 1
                }
                groupByDate[groupIndex].messages.push(message)
            })

            return groupByDate
        }
    },
    watch: {
        filter () {
            this.getChatRooms({ chatable_type: 'file', chatable_id: this.meta.hash })
        },
        selectedChatRoom (val, old) {
            if (val && val?.id !== old?.id) {
                this.getChatRoomMembers(this.selectedChatRoom)
                this.getChatRoomMessages(this.selectedChatRoom, ({ data, meta }) => {
                    this.oldestUnreadMessageId = meta?.oldest_unread_message_id ?? null
                    if (this.oldestUnreadMessageId) {
                        this.$refs.chatMessagesContainer.scrollToElement(`[data-message-id="${this.oldestUnreadMessageId}"]`)
                    } else {
                        this.$refs.chatMessagesContainer.scrollToEnd()
                    }
                })
            } else if (val === null) {
                this.selectedChatRoomMessages = []
            }
        }
    },
    mounted () {
        if (this.meta?.chatting) {
            this.getChatRooms({ chatable_type: 'file', chatable_id: this.meta.hash })
            this.setUpRealTime()
        }
    },
    beforeDestroy () {
        this.destroyRealTime()
    },
    methods: {
        openChatRoom (room) {
            this.selectedChatRoom = room
        },
        messageSent (message) {
            this.rooms.find(r => r.id === message.chat_room_id).latest_message = message
            if (this.messagesGroupByDateOrderByLatest.at(-1).messages.at(-1).has_next_messages) {
                this.getChatRoomMessages(this.selectedChatRoom, () => {
                    this.$refs.chatMessagesContainer.scrollToEnd()
                })
                return
            }

            this.selectedChatRoomMessages.push(message)
            this.$nextTick(() => {
                this.$refs.chatMessagesContainer.scrollToEnd()
            })
        },
        destroyRealTime () {
            window.Echo.private(`Tenant.${this.$auth.user.tenant_id}.User.${this.$auth.user.id}`)
                .stopListening('.ChatRoomMessage.created')
                .stopListening('.ChatRoom.updated')
                .stopListening('.ChatRoom.deleted')
        },
        setUpRealTime () {
            window.Echo.private(`Tenant.${this.$auth.user.tenant_id}.User.${this.$auth.user.id}`)
                .listen('.ChatRoom.updated', (chatRoom) => {
                    if (this.filter !== null && this.filter !== chatRoom.status) {
                        this.rooms.splice(this.rooms.findIndex(r => r.id === chatRoom.id), 1)
                    } else {
                        const room = this.rooms.find(r => r.id === chatRoom.id)
                        if (room){
                            room.status = chatRoom.status
                            room.name = chatRoom.name
                            const roomIndex = this.rooms.findIndex(r => r.id === chatRoom.id)
                            if (roomIndex !== -1) {
                                this.rooms.splice(roomIndex, 1, room)
                            }
                        }
                    }
                    if (this.selectedChatRoom?.id === chatRoom.id) {
                        this.selectedChatRoom.status = chatRoom.status
                        this.selectedChatRoom.name = chatRoom.name
                    }
                })
                .listen('.ChatRoom.deleted', (chatRoom) => {
                    const roomIndex = this.rooms.findIndex(r => r.id === chatRoom.id)
                    if (roomIndex !== -1) {
                        this.rooms.splice(roomIndex, 1)
                    }
                })
                .listen('.ChatRoomMessage.created', (message) => {
                    const { chat_room_id } = message
                    if (this.selectedChatRoom?.id === chat_room_id) {
                        return
                    }
                    const chatRoom = this.rooms.find(r => r.id === chat_room_id)
                    if (chatRoom) {
                        chatRoom.latest_message = message
                        if (message.type === 'Text') {
                            chatRoom.unread_messages_count++
                        }
                        return
                    }
                    if (this.rooms.findIndex(r => r.id === chat_room_id) === -1){
                        if (message.type === 'ChatRoomOpened' && (this.filter === null || this.filter === 'Opened')) {
                            this.getChatRooms({ chatable_type: 'file', chatable_id: this.meta.hash })
                        } else if (message.type === 'ChatRoomClosed' && (this.filter === null || this.filter === 'Closed')) {
                            this.getChatRooms({ chatable_type: 'file', chatable_id: this.meta.hash })
                        }
                    }
                })
                .listen('.ChatRoomMessage.created', (message) => {
                    const { chat_room_id } = message
                    if (this.selectedChatRoom?.id !== chat_room_id) {
                        return
                    }
                    if (this.lastSelectedChatRoomMessage.has_next_messages) {
                        this.thereIsNewMessages = true
                        return
                    }
                    this.selectedChatRoomMessages.push(message)
                    if (this.$refs.chatMessagesContainer?.isScrollAtTheEnd()) {
                        this.$nextTick(() => {
                            this.$refs.chatMessagesContainer.scrollToEnd()
                        })
                        this.markMessagesAsRead()
                        return
                    }
                    this.thereIsNewMessages = true
                })
        },
        updateChatRoomStatus (room, isDone) {
            this.updateChatRoomStatusRequest.fill({ status: isDone ? 'Closed' : 'Opened' })
            this.updateChatRoomStatusRequest.patch('/v1/chat-rooms/' + room.id)
                .then((res) => {
                    const room = res.data.data
                    if ((this.filter === 'Opened' && isDone) || (this.filter === 'Closed' && !isDone)) {
                        this.rooms.splice(this.rooms.findIndex(r => r.id === room.id), 1)
                    } else {
                        const roomIndex = this.rooms.findIndex(r => r.id === room.id)
                        if (roomIndex !== -1) {
                            this.rooms.splice(roomIndex, 1, room)
                        } else {
                            this.rooms.push(room)
                        }
                    }
                    if (this.selectedChatRoom?.id === room.id) {
                        this.selectedChatRoom.status = room.status
                        this.selectedChatRoomMessages.push(room.latest_message)
                    }
                })
        },
        getChatRooms ({ chatable_type, chatable_id }) {
            this.getChatRoomsRequest.fill({
                chatable_type,
                chatable_id,
                status: this.filter
            })
            this.getChatRoomsRequest.get('/v1/chat-rooms')
                .then((res) => {
                    this.rooms = res.data.data
                    if (this.awaitingChatRoomId !== null) {
                        const awaitingChatRoom = this.rooms.find(room => room.id === this.awaitingChatRoomId)
                        if (awaitingChatRoom) {
                            this.openChatRoom(awaitingChatRoom)
                        }
                        this.awaitingChatRoomId = null
                    }
                })
        },
        getChatRoomMembers (chatRoom) {
            this.getChatRoomMembersRequest.get(`/v1/chat-rooms/${chatRoom.id}/chat-room-members`)
                .then((res) => {
                    this.selectedChatRoomMembers = res.data.data
                })
        },
        getChatRoomMessages (chatRoom, then = null) {
            this.getChatRoomMessagesRequest.get(`/v1/chat-rooms/${chatRoom.id}/chat-room-messages`)
                .then((res) => {
                    const { data, meta } = res.data
                    this.selectedChatRoomMessages = data
                    this.oldestUnreadMessageId = meta?.oldest_unread_message_id ?? null
                    this.selectedChatRoom.unread_messages_count = meta?.unread_messages_count ?? 0
                    this.$nextTick(() => {
                        then && then({ data, meta })
                    })
                })
        },
        loadChatRoomMessages (dir) {
            const message = this.messagesGroupByDateOrderByLatest.at(dir === 'up' ? 0 : -1).messages.at(dir === 'up' ? 0 : -1)
            if (dir === 'up' && !message.has_previous_messages) {
                return
            }
            if (dir === 'down' && !message.has_next_messages) {
                return
            }
            if (this.loadChatRoomMessagesRequest.busy || this.getChatRoomMessagesRequest.busy) {
                return
            }
            this.loadChatRoomMessagesRequest.fill({
                message_id: message.id,
                dir: dir === 'up' ? 'previous' : 'next'
            })
            this.loadChatRoomMessagesRequest.get(`/v1/chat-rooms/${this.selectedChatRoom.id}/chat-room-messages`)
                .then((res) => {
                    if (dir === 'up') {
                        this.$refs.chatMessagesContainer.persistScroll(() => {
                            this.selectedChatRoomMessages.push(...res.data.data)
                        })
                    } else {
                        this.selectedChatRoomMessages.push(...res.data.data)
                    }
                })
        },
        handleCreatedChatRoom (room) {
            this.rooms.push(room)
        },
        handleUpdatedChatRoom (room) {
            this.rooms.splice(this.rooms.findIndex(r => r.id === room.id), 1, room)
            if (this.selectedChatRoom?.id === room.id) {
                this.selectedChatRoom = room
                this.selectedChatRoomMessages.push(room.latest_message)
            }
        },
        closeChatRoom () {
            if (this.rooms.find(r => r.id === this.selectedChatRoom.id)) {
                this.rooms.find(r => r.id === this.selectedChatRoom.id).unread_messages_count = 0
            }
            this.selectedChatRoom = null
        },
        handleThereIsNewMessages () {
            this.thereIsNewMessages = false
            if (this.lastSelectedChatRoomMessage.has_next_messages) {
                this.getChatRoomMessages(this.selectedChatRoom, () => {
                    if (this.oldestUnreadMessageId) {
                        this.$refs.chatMessagesContainer.scrollToElement(`[data-message-id="${this.oldestUnreadMessageId}"]`)
                    } else {
                        this.$refs.chatMessagesContainer.scrollToEnd()
                    }
                    this.markMessagesAsRead()
                })
                return
            }
            this.$refs.chatMessagesContainer.scrollToEnd()
            this.markMessagesAsRead()
        },
        markMessagesAsRead () {
            this.$axios.$post(`/v1/chat-rooms/${this.selectedChatRoom.id}/chat-room-message-views`)
        },
        getEmptyStateTitle () {
            if (!this.meta?.chatting) {
                return this.$auth.user?.is_tenant_owner ? this.$t('يمكنك تفعيل ميزة المناقشات من الاعدادات') : this.$t('يمكن لقائد الفريق تفعيل ميزة المناقشات')
            }
            switch (this.filter) {
            case 'Opened':
                return this.$t('لم يتم ايجاد اي مناقشات مفتوحة.')
            case 'Closed':
                return this.$t('لم يتم ايجاد اي مناقشات مغلقة.')
            default:
                return this.$t('لم يتم ايجاد اي مناقشات في هذا الملف.')
            }
        },
        createChatRoom (name = null, chatable_type = 'file', chatable_id = null, then = undefined) {
            this.createOrUpdateChatRoomRequest.name = name
            this.createOrUpdateChatRoomRequest.chatable_type = chatable_type
            this.createOrUpdateChatRoomRequest.chatable_id = chatable_id ?? this.meta.hash
            this.createOrUpdateChatRoomRequest.post('/v1/chat-rooms')
                .then((res) => {
                    this.handleCreatedChatRoom(res.data.data)
                    if (typeof then === 'function') {
                        then(res.data.data)
                    }
                })
        },
        updateChatRoom (name) {
            this.createOrUpdateChatRoomRequest.name = name
            this.createOrUpdateChatRoomRequest.patch('/v1/chat-rooms/' + this.modal.extra.room.id)
                .then((res) => {
                    this.handleUpdatedChatRoom(res.data.data)
                })
        }
    }
}
